import React from "react";
import styles from "./solutions.module.css";
import { Section, SectionIntro } from "../../../../COMPONENTS/UI";
import Reveal from "../../../../COMPONENTS/ANIMATION/Reveal";
import { centralized, startup } from "../../../../CONTENT/sponsors";

const OurSolutions = () => (
  <Section tone="light" id="solutions" labelledBy="solutions-title">
    <SectionIntro
      id="solutions-title"
      eyebrow="Our solutions"
      title="From site selection to first subject, fast."
    />

    <div className={styles.startup}>
      <Reveal className={styles.figureBlock}>
        <p className={styles.figure}>
          10<span>days</span>
        </p>
        <p className={styles.figureCaption}>
          Site selection to first subject enrolled, as fast as
        </p>
      </Reveal>
      <Reveal delay={0.1} className={styles.startupCopy}>
        <h3 className={styles.h3}>{startup.title}</h3>
        <p className={styles.text}>{startup.text}</p>
        <ol className={styles.steps}>
          {startup.steps.map((s, i) => (
            <li key={s}>
              <span aria-hidden="true">{i + 1}</span>
              {s}
            </li>
          ))}
        </ol>
      </Reveal>
    </div>

    <div className={styles.central}>
      <div className={styles.centralHead}>
        <h3 className={styles.h3}>{centralized.title}</h3>
        <p className={styles.text}>{centralized.text}</p>
      </div>
      <div className={styles.groups}>
        {centralized.groups.map((g, i) => (
          <Reveal key={g.title} delay={i * 0.08} className={styles.group}>
            <h4 className={styles.groupTitle}>{g.title}</h4>
            <ul className={styles.items}>
              {g.items.map((it) => (
                <li key={it}>{it}</li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>
    </div>
  </Section>
);

export default OurSolutions;
